import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import sdkComponents from 'hy-rtc-sdk-components'
import 'hy-rtc-sdk-components/lib/hy-rtc-sdk-components.css'
import '@/styles/main.less'
import '@/styles/tailwindcss.css'

Vue.config.productionTip = false
Vue.use(sdkComponents, {
  store,
  sdkParams: {
    version: '0.2.0',
    serviceVersion: '0.3.0'
  }
})
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
